import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import PaymentService from '../../../services/PaymentService'
import { useSettings } from '../../../hooks/useSettings'
import { getTextClass } from '../../../utils/themeUtils'

// Fatture (abbonamenti ai moduli) e ricevute (ricariche) dal fornitore dei
// pagamenti. Fino al 28/09 la scheda era vuota per costruzione. File condiviso
// con il portale (shared/MANIFEST.txt): niente import che il portale non ha.
const Invoices = () => {
  // undefined = in caricamento, null = errore, 'central' = solo sul portale
  const [docs, setDocs] = useState(undefined)
  const { currentTheme } = useSettings()
  const { t, i18n } = useTranslation('payments')

  useEffect(() => {
    let vivo = true
    PaymentService.getInvoices()
      .then((r) => vivo && setDocs(Array.isArray(r.data) ? r.data : []))
      .catch((e) => {
        if (!vivo) return
        // Sulla VM le chiavi dei pagamenti non ci sono: il backend risponde
        // 403 e i documenti si consultano sul portale.
        setDocs(e?.response?.status === 403 ? 'central' : null)
      })
    return () => {
      vivo = false
    }
  }, [])

  const centered = (key) => (
    <div
      className={clsx(
        'flex items-center justify-center h-full',
        getTextClass(currentTheme)
      )}
    >
      {t(key)}
    </div>
  )

  if (docs === undefined) return centered('rechargingStation.invoices.loading')
  if (docs === null) return centered('rechargingStation.invoices.error')
  if (docs === 'central')
    return centered('rechargingStation.invoices.centralOnly')
  if (!docs.length) return centered('rechargingStation.invoices.noInvoices')

  const amount = (d) =>
    new Intl.NumberFormat(i18n.language, {
      style: 'currency',
      currency: (d.currency || 'eur').toUpperCase(),
    }).format((d.amount_cents || 0) / 100)

  return (
    <div className={clsx('h-full overflow-y-auto', getTextClass(currentTheme))}>
      <table className="w-full text-sm" data-testid="invoices-table">
        <thead>
          <tr className="text-left">
            <th className="py-2 pr-3">
              {t('rechargingStation.invoices.columns.date')}
            </th>
            <th className="py-2 pr-3">
              {t('rechargingStation.invoices.columns.document')}
            </th>
            <th className="py-2 pr-3 text-right">
              {t('rechargingStation.invoices.columns.amount')}
            </th>
            <th className="py-2 pr-3">
              {t('rechargingStation.invoices.columns.status')}
            </th>
            <th className="py-2" />
          </tr>
        </thead>
        <tbody>
          {docs.map((d) => (
            <tr key={d.id} className="border-t border-current/20">
              <td className="py-2 pr-3">
                {new Date(d.date * 1000).toLocaleDateString(i18n.language)}
              </td>
              <td className="py-2 pr-3">
                {t(`rechargingStation.invoices.kind.${d.kind}`)}
                {d.number ? ` ${d.number}` : ''}
              </td>
              <td className="py-2 pr-3 text-right">{amount(d)}</td>
              <td className="py-2 pr-3">
                {t(`rechargingStation.invoices.status.${d.status}`)}
              </td>
              <td className="py-2 text-right">
                {d.url && (
                  <a
                    href={d.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline"
                  >
                    {t('rechargingStation.invoices.open')}
                  </a>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default Invoices
